var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6778 9.40047C21.4338 8.86038 21.228 8.31867 20.9458 7.82169C19.319 4.94964 16.8447 3.29603 13.5757 2.90642C8.79625 2.33705 4.3991 5.36121 3.16439 10.0081C1.77594 15.2365 5.03517 20.6024 10.3628 21.846C14.5818 22.831 18.9847 20.7797 21.0482 16.8567C21.1507 16.6623 21.2613 16.5704 21.4818 16.5582C21.9728 16.5251 22.4352 16.315 22.7832 15.9669C23.2289 15.5391 23.6429 15.0771 24.07 14.6297C24.2457 14.4365 24.4325 14.2537 24.6296 14.0823C24.4794 15.5517 24.0328 16.9753 23.3168 18.2672C21.4256 21.6712 18.5821 23.8161 14.7559 24.6058C9.0972 25.7731 3.20587 22.6391 0.974761 17.2781C-1.97375 10.1968 2.07446 2.62255 8.9817 0.508566C14.9446 -1.31585 21.2247 1.97266 23.6494 7.11161C23.6893 7.19295 23.7169 7.35156 23.6714 7.39792C23.015 8.07303 22.3448 8.73512 21.6778 9.40047Z",
    fill: "url(#paint0_linear_951_19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6492 24.7272C21.7583 23.4355 23.49 21.7738 24.7622 19.624C24.8435 19.6972 24.9143 19.7525 24.9761 19.8152C26.2962 21.1345 27.6204 22.4489 28.9332 23.7755C30.4575 25.3153 30.4192 27.6676 28.8575 29.0861C27.4854 30.3338 25.2599 30.3062 23.8739 28.973C22.4709 27.6228 21.1141 26.2263 19.7371 24.8484C19.7052 24.8099 19.6759 24.7694 19.6492 24.7272Z",
    fill: "url(#paint1_linear_951_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0531 12.6929C21.1173 12.5837 21.1902 12.4797 21.2711 12.3822C23.1147 10.5386 24.9584 8.69489 26.8021 6.85123C27.1827 6.47138 27.5935 6.3998 27.9815 6.63568C28.5077 6.96103 28.5948 7.60442 28.1482 8.06642C27.5203 8.71713 26.8777 9.34994 26.2335 9.98356C24.7505 11.4428 23.2655 12.8995 21.7786 14.3539C21.2255 14.8964 20.7822 14.8923 20.2332 14.3441L17.5848 11.6965C17.5035 11.6152 17.4262 11.5453 17.2928 11.4184C17.229 11.5203 17.1578 11.6173 17.0797 11.7087C15.6254 13.1674 14.1692 14.6242 12.711 16.0791C12.1498 16.6395 11.7033 16.6403 11.1469 16.0791C10.4962 15.4283 9.84549 14.7703 9.17445 14.096L6.11613 17.1625C5.7981 16.6208 5.4939 16.1132 5.20514 15.5959C5.17749 15.5471 5.22141 15.4202 5.27266 15.3714C6.36666 14.327 7.46066 13.2835 8.56686 12.2537C8.96704 11.8812 9.45019 11.9186 9.86827 12.3294C10.484 12.9337 11.0883 13.5494 11.7008 14.157C11.7708 14.2278 11.8448 14.2937 11.9294 14.3726C12.0197 14.2912 12.101 14.214 12.1791 14.1367L16.5714 9.74443C17.1188 9.19784 17.5621 9.19865 18.1168 9.75094C19.0709 10.7034 20.0225 11.6599 21.0531 12.6929Z",
    fill: "url(#paint2_linear_951_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_951_19",
    x1: 17.2103,
    y1: 1.6567,
    x2: 5.55073,
    y2: 21.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_951_19",
    x1: 26.919,
    y1: 20.3157,
    x2: 22.08,
    y2: 28.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_951_19",
    x1: 21.4354,
    y1: 7.21088,
    x2: 18.597,
    y2: 18.0172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting);
export default __webpack_public_path__ + "static/media/testing.c1ec58f2cb9cfa569a983e4d39c502da.svg";
export { ForwardRef as ReactComponent };